import React from 'react';
import { Link } from 'react-router-dom';
export const ProductsSection = () => {
  return <section className="py-24 border-t border-gray-100 relative" id="products" data-id="element-611">
      <div className="max-w-4xl mx-auto mb-12" data-id="element-612">
        <h2 className="font-serif text-4xl font-bold text-center mb-6" data-id="element-613">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-614">
            Products
          </span>
        </h2>
        <p className="text-lg text-gray-700 text-center mb-12" data-id="element-615">
          AI-based products designed to help creators monetize and grow.
        </p>
      </div>
      <div className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden" data-id="element-616">
        <div className="p-8" data-id="element-617">
          <div className="flex flex-col md:flex-row gap-8" data-id="element-618">
            <div className="md:w-1/2" data-id="element-619">
              <div className="inline-flex mb-6" data-id="element-620">
                <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/xckowmcscdatvwqg3ex8v2/debbab01-79d9-49e0-a766-2a2a9aeb34ad/nf_icon.png" alt="Newsfiliate Icon" className="w-12 h-12" data-id="element-621" />
              </div>
              <h3 className="font-serif text-3xl font-bold mb-4" data-id="element-622">
                <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/xckowmcscdatvwqg3ex8v2/debbab01-79d9-49e0-a766-2a2a9aeb34ad/Nf_final.png" alt="Newsfiliate" className="h-12" data-id="element-623" />
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-624">
                Intelligent newsletter automation for Amazon affiliate links and
                product boxes.
              </p>
              <p className="text-gray-900 font-medium mb-6" data-id="element-625">
                Save time while maximizing your affiliate revenue.
              </p>
              <Link to="/products/newsfiliate" data-id="element-626">
                <button className="bg-[#5e60ce] hover:bg-[#4c4db6] text-white px-8 py-3 rounded-lg transition-all hover:shadow-lg hover:-translate-y-1" data-id="element-627">
                  Learn More
                </button>
              </Link>
            </div>
            <div className="md:w-1/2 bg-gray-50 rounded-xl p-6" data-id="element-628">
              <h4 className="font-medium text-lg mb-4" data-id="element-629">Key Features</h4>
              <ul className="space-y-3" data-id="element-630">
                {['Auto-insert affiliate links', 'Product box generator', 'Revenue analytics', 'Link health monitoring'].map((feature, idx) => <li key={idx} className="flex items-start" data-id="element-631">
                    <svg className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-632">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-633" />
                    </svg>
                    <span data-id="element-634">{feature}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
};